// @flow
class HideShowContentAside {
    el: HTMLElement;

    constructor(el: HTMLElement) {
        this.el = el;
        this.attachHandlers();
        this.toggleReadability();
    }

    attachHandlers = () => {
        window.addEventListener("resize", this.toggleReadability);
    };

    makeReadable = () => {
        this.el.classList.remove("rs_skip");
    };

    makeUnreadable = () => {
        this.el.classList.add("rs_skip");
    };

    toggleReadability = () => {
        if (window.innerWidth < 1024) {
            this.makeUnreadable();
        } else {
            this.makeReadable();
        }
    };
}

const els = document.querySelectorAll(".page-content__aside");
els.forEach((el: HTMLElement) => {
    new HideShowContentAside(el);
});
